<!-- Start Hero -->
<section class="relative table w-full py-36 bg-[url('/assets/images/parallax/archer_1920x1200.jpg')] bg-center bg-no-repeat">
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center mt-10">
      <h3 class="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">{{ 'CONQUER_ACCOUNTS.TITLE' | translate }}</h3>

    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->
<div class="relative">
  <div class="shape absolute start-0 end-0 sm:-bottom-px -bottom-[2px] overflow-hidden z-1 text-white dark:text-slate-900">
    <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!-- End Hero -->

<section class="relative md:pt-24 py-8">
  <div class="container">
    <div class="grid md:grid-cols-12 gap-[30px]">
      <div class="lg:col-span-6 md:col-span-6">
        <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
          <h5 class="text-lg font-semibold mb-4">{{ "CONQUER_ACCOUNTS.CREATION.TITLE" | translate }}:</h5>
          <form [formGroup]="registerForm" (ngSubmit)="registerAccount()">
            <div class="mb-4">
              <label class="font-semibold" for="userName">{{ "CONQUER_ACCOUNTS.CREATION.USERNAME" | translate }}</label>
              <input id="userName" type="text" formControlName="userName"
                     class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0"
                     placeholder="john">
              <div *ngIf="registerForm.get('userName')?.invalid && registerForm.get('userName')?.touched" class="text-red-500 mt-1 text-sm">
                {{ 'CONQUER_ACCOUNTS.CREATION.ERRORS.USERNAME_REQUIRED' | translate }}
              </div>
            </div>

            <div class="mb-4">
              <label class="font-semibold" for="password">{{ "CONQUER_ACCOUNTS.CREATION.PASSWORD" | translate }}</label>
              <input id="password" type="password" formControlName="password"
                     class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0"
                     placeholder="********">
              <div *ngIf="registerForm.get('password')?.invalid && registerForm.get('password')?.touched" class="text-red-500 mt-1 text-sm">
                {{ 'CONQUER_ACCOUNTS.CREATION.ERRORS.PASSWORD_REQUIRED' | translate }}
              </div>
            </div>

            <div class="mb-4">
              <label class="font-semibold"
                     for="confirmPassword">{{ "CONQUER_ACCOUNTS.CREATION.CONFIRM_PASSWORD" | translate }}</label>
              <input id="confirmPassword" type="password" formControlName="confirmPassword"
                     class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0"
                     placeholder="********">
              <div *ngIf="registerForm.errors?.['passwordMismatch'] && registerForm.get('confirmPassword')?.touched" class="text-red-500 mt-1 text-sm">
                {{ 'CONQUER_ACCOUNTS.CREATION.ERRORS.PASSWORDS_DONT_MATCH' | translate }}
              </div>
            </div>

            <!-- Backend error message -->
            <div *ngIf="registerError" class="mb-4 p-3 bg-red-50 text-red-700 rounded-md dark:bg-red-900/20 dark:text-red-400">
              <p class="text-sm font-medium">{{ registerError }}</p>
            </div>

            <button type="submit" [disabled]="registerForm.invalid || registerLoading"
                    class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md w-full flex items-center justify-center"
                    [ngClass]="{'opacity-50 cursor-not-allowed': registerForm.invalid || registerLoading}">
              <span *ngIf="registerLoading" class="inline-block mr-2">
                <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
              {{ "CONQUER_ACCOUNTS.CREATION.SUBMIT" | translate }}
            </button>
          </form>
        </div>
      </div>
      <div class="lg:col-span-6 md:col-span-6">
        <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
          <h5 class="text-lg font-semibold mb-4">{{ "CONQUER_ACCOUNTS.VIP.TITLE" | translate }}:</h5>
          <div class="mb-4" *ngIf="vipLoading">
            <app-loading />
          </div>
          <div class="grid grid-cols-2 gap-4 mb-6" *ngIf="vipInfo">
            <div>
              <p class="text-slate-400">{{ 'CONQUER_VIP.INFO.VIP_LEVEL' | translate }}</p>
              <p class="font-semibold">{{ vipInfo.vipLevel }}</p>
            </div>
            <div>
              <p class="text-slate-400">{{ 'CONQUER_VIP.INFO.VIP_POINTS' | translate }}</p>
              <p class="font-semibold">{{ vipInfo.vipPoint }} / {{ vipInfo.vipPointNext }}</p>
            </div>
            <div>
              <p class="text-slate-400">{{ 'CONQUER_VIP.INFO.BIND_COUNT' | translate }}</p>
              <p class="font-semibold">{{ vipInfo.vipBindNum }}</p>
            </div>
            <div>
              <p class="text-slate-400">{{ 'CONQUER_VIP.INFO.BIND_LIMIT' | translate }}</p>
              <p class="font-semibold">{{ vipInfo.vipBindLimit }}</p>
            </div>
          </div>
          <a [routerLink]="['/user/conquer-vip']"
                  class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md w-full">{{ "CONQUER_ACCOUNTS.VIP.GOTO" | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="relative md:pb-24 md:pt-8 py-8">
  <div class="container">
    <div class="grid md:grid-cols-12 gap-[30px]">
      <div class="lg:col-span-12 md:col-span-12">
        <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
          <h5 class="text-lg font-semibold mb-4">{{ "CONQUER_ACCOUNTS.LIST.TITLE" | translate }}:</h5>
          <p class="text-slate-400 mb-4">{{ "CONQUER_ACCOUNTS.LIST.DESCRIPTION" | translate }}</p>

          <div *ngIf="loading" class="flex justify-center items-center py-10">
            <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
          </div>

          <table class="table-auto w-full border-collapse border border-slate-400" *ngIf="!loading && gameAccounts?.length">
            <thead>
            <tr class="bg-slate-100 dark:bg-slate-700">
              <th class="border border-slate-300 dark:border-slate-600 p-2">{{ "CONQUER_ACCOUNTS.LIST.ID" | translate }}</th>
              <th class="border border-slate-300 dark:border-slate-600 p-2">{{ "CONQUER_ACCOUNTS.LIST.USERNAME" | translate }}</th>
              <th class="border border-slate-300 dark:border-slate-600 p-2">{{ "CONQUER_ACCOUNTS.LIST.ACCOUNT_TYPE.TITLE" | translate }}</th>
              <th class="border border-slate-300 dark:border-slate-600 p-2">{{ "CONQUER_ACCOUNTS.LIST.VIP.TITLE" | translate }}</th>
              <th class="border border-slate-300 dark:border-slate-600 p-2">{{ "CONQUER_ACCOUNTS.LIST.ACCOUNT_STATUS.TITLE" | translate }}</th>
              <th class="border border-slate-300 dark:border-slate-600 p-2">{{ "CONQUER_ACCOUNTS.LIST.ACTION" | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let account of gameAccounts; let even = even" [ngClass]="even ? 'bg-slate-50 dark:bg-slate-800' : 'bg-white dark:bg-slate-900'">
              <td class="border border-slate-300 dark:border-slate-600 p-2">{{ account.id }}</td>
              <td class="border border-slate-300 dark:border-slate-600 p-2">{{ account.userName }}</td>
              <td class="border border-slate-300 dark:border-slate-600 p-2 text-center">{{ 'CONQUER_ACCOUNTS.LIST.ACCOUNT_TYPE.NORMAL_USER' | translate }}</td>
              <td *ngIf="account.vipLevel > 0" class="border border-slate-300 dark:border-slate-600 p-2 text-center">
                <strong>{{ "CONQUER_ACCOUNTS.LIST.VIP.LEVEL" | translate }}</strong>: {{ account.vipLevel }}
                <br/> <strong>{{ "CONQUER_ACCOUNTS.LIST.VIP.BIND_DATE" | translate }}</strong>: {{ account.vipBindDate | date: 'yyyy-MM-dd HH:mm' }}
              </td>
              <td *ngIf="account.vipLevel <= 0" class="border border-slate-300 dark:border-slate-600 p-2 text-center">
                {{ "CONQUER_ACCOUNTS.LIST.VIP.NO_VIP" | translate }}
              </td>
              <td class="border border-slate-300 dark:border-slate-600 p-2 text-center">
                {{ getAccountStatusText(account) }}
              </td>
              <td class="border border-slate-300 dark:border-slate-600 p-2" *ngIf="!account.deleteTime">
                <button
                  class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md me-2"
                  [title]="'CONQUER_ACCOUNTS.LIST.CHANGE_PASSWORD' | translate"
                  (click)="openPasswordChangeModal(account)">
                  <i class="uil uil-edit h-28 w-28 fill-violet-600/5 mx-auto rotate-[30deg]"></i>
                </button>
                <button
                  class="btn bg-red-600 hover:bg-red-700 border-red-600 hover:border-red-700 text-white rounded-md"
                  [title]="'CONQUER_ACCOUNTS.LIST.DELETE_ACCOUNT' | translate"
                  (click)="openDeleteAccountModal(account)">
                  <i class="uil uil-trash-alt h-28 w-28 fill-violet-600/5 mx-auto rotate-[30deg]"></i>
                </button>
              </td>
              <td class="border border-slate-300 dark:border-slate-600 p-2" *ngIf="account.deleteTime">
                &nbsp;
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- Password Change Modal -->
<div [ngClass]="showPasswordModal ? '' : 'hidden'" class="fixed z-50 overflow-hidden inset-0 m-auto flex items-center justify-center w-full h-[100vh]" style="background-color: #000000a1;">
  <div class="relative w-full h-auto max-w-md p-4">
    <div class="relative bg-white dark:bg-slate-900 rounded-lg shadow dark:shadow-gray-800">
      <div class="flex justify-between items-center px-6 py-4 border-b border-gray-100 dark:border-gray-700">
        <h5 class="text-xl font-semibold">{{ 'CONQUER_ACCOUNTS.MODALS.PASSWORD_CHANGE.TITLE' | translate }}</h5>
        <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ms-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" (click)="closePasswordModal()">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
        </button>
      </div>
      <div class="p-6">
        <form class="text-start" (ngSubmit)="changePassword()" [formGroup]="passwordForm">
          <div class="grid grid-cols-1">
            <div class="mb-4">
              <label class="font-semibold">{{ 'CONQUER_ACCOUNTS.MODALS.PASSWORD_CHANGE.ACCOUNT' | translate }}:</label>
              <p class="mt-1">{{ selectedAccount?.userName }}</p>
            </div>

            <div class="mb-4">
              <label class="font-semibold" for="password">{{ 'CONQUER_ACCOUNTS.MODALS.PASSWORD_CHANGE.NEW_PASSWORD' | translate }}:</label>
              <input id="password" type="password" formControlName="password"
                     class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3"
                     placeholder="********">
              <div *ngIf="passwordForm.get('password')?.invalid && passwordForm.get('password')?.touched" class="text-red-500 mt-1 text-sm">
                {{ 'CONQUER_ACCOUNTS.MODALS.PASSWORD_CHANGE.ERRORS.NEW_PASSWORD_REQUIRED' | translate }}
              </div>
            </div>

            <div class="mb-4">
              <label class="font-semibold" for="confirmPassword">{{ 'CONQUER_ACCOUNTS.MODALS.PASSWORD_CHANGE.CONFIRM_PASSWORD' | translate }}:</label>
              <input id="confirmPassword" type="password" formControlName="confirmPassword"
                     class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3"
                     placeholder="********">
              <div *ngIf="passwordForm.errors?.['passwordMismatch'] && passwordForm.get('confirmPassword')?.touched" class="text-red-500 mt-1 text-sm">
                {{ 'CONQUER_ACCOUNTS.MODALS.PASSWORD_CHANGE.ERRORS.PASSWORDS_DONT_MATCH' | translate }}
              </div>
            </div>

            <!-- Backend error message -->
            <div *ngIf="passwordChangeError" class="mb-4 p-3 bg-red-50 text-red-700 rounded-md dark:bg-red-900/20 dark:text-red-400">
              <p class="text-sm font-medium">{{ passwordChangeError }}</p>
            </div>

            <div class="flex justify-end space-x-3">
              <button type="button" class="btn bg-gray-300 hover:bg-gray-400 border-gray-300 hover:border-gray-400 text-gray-800 rounded-full" (click)="closePasswordModal()">
                {{ 'CONQUER_ACCOUNTS.MODALS.PASSWORD_CHANGE.CANCEL' | translate }}
              </button>
              <button type="submit" [disabled]="passwordForm.invalid || passwordChangeLoading"
                      class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full flex items-center justify-center"
                      [ngClass]="{'opacity-50 cursor-not-allowed': passwordForm.invalid || passwordChangeLoading}">
                <span *ngIf="passwordChangeLoading" class="inline-block mr-2">
                  <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </span>
                {{ 'CONQUER_ACCOUNTS.MODALS.PASSWORD_CHANGE.SUBMIT' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- End Password Change Modal -->

<!-- Delete Account Modal -->
<div [ngClass]="showDeleteModal ? '' : 'hidden'" class="fixed z-50 overflow-hidden inset-0 m-auto flex items-center justify-center w-full h-[100vh]" style="background-color: #000000a1;">
  <div class="relative w-full h-auto max-w-md p-4">
    <div class="relative bg-white dark:bg-slate-900 rounded-lg shadow dark:shadow-gray-800">
      <div class="flex justify-between items-center px-6 py-4 border-b border-gray-100 dark:border-gray-700">
        <h5 class="text-xl font-semibold">{{ 'CONQUER_ACCOUNTS.MODALS.DELETE_ACCOUNT.TITLE' | translate }}</h5>
        <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ms-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" (click)="closeDeleteModal()">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
        </button>
      </div>
      <div class="p-6">
        <form class="text-start" (ngSubmit)="deleteAccount()" [formGroup]="deleteForm">
          <div class="grid grid-cols-1">
            <div class="mb-4">
              <div class="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-red-900/20 dark:text-red-400" role="alert">
                <span class="font-medium">{{ 'CONQUER_ACCOUNTS.MODALS.DELETE_ACCOUNT.WARNING' | translate }}</span>
              </div>
              <p class="mb-2">{{ 'CONQUER_ACCOUNTS.MODALS.DELETE_ACCOUNT.CONFIRMATION_TEXT' | translate }}</p>
              <p class="font-semibold">{{ selectedAccount?.userName }}</p>
            </div>

            <div class="mb-4">
              <label class="font-semibold" for="confirmationText">{{ 'CONQUER_ACCOUNTS.MODALS.DELETE_ACCOUNT.CONFIRMATION_PROMPT' | translate }}</label>
              <input id="confirmationText" type="text" formControlName="confirmationText"
                     class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-3"
                     placeholder="{{ 'CONQUER_ACCOUNTS.MODALS.DELETE_ACCOUNT.CONFIRMATION_PLACEHOLDER' | translate }}">
              <div *ngIf="deleteForm.get('confirmationText')?.invalid && deleteForm.get('confirmationText')?.touched" class="text-red-500 mt-1 text-sm">
                {{ 'CONQUER_ACCOUNTS.MODALS.DELETE_ACCOUNT.ERRORS.CONFIRMATION_REQUIRED' | translate }}
              </div>
            </div>

            <!-- Backend error message -->
            <div *ngIf="deleteAccountError" class="mb-4 p-3 bg-red-50 text-red-700 rounded-md dark:bg-red-900/20 dark:text-red-400">
              <p class="text-sm font-medium">{{ deleteAccountError }}</p>
            </div>

            <div class="flex justify-end space-x-3">
              <button type="button" class="btn bg-gray-300 hover:bg-gray-400 border-gray-300 hover:border-gray-400 text-gray-800 rounded-full" (click)="closeDeleteModal()">
                {{ 'CONQUER_ACCOUNTS.MODALS.DELETE_ACCOUNT.CANCEL' | translate }}
              </button>
              <button type="submit" [disabled]="deleteForm.invalid || deleteAccountLoading"
                      class="btn bg-red-600 hover:bg-red-700 border-red-600 hover:border-red-700 text-white rounded-full flex items-center justify-center"
                      [ngClass]="{'opacity-50 cursor-not-allowed': deleteForm.invalid || deleteAccountLoading}">
                <span *ngIf="deleteAccountLoading" class="inline-block mr-2">
                  <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </span>
                {{ 'CONQUER_ACCOUNTS.MODALS.DELETE_ACCOUNT.SUBMIT' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- End Delete Account Modal -->
